import { useMutation, useQueryClient } from '@tanstack/react-query';
import { duplicateProduct } from '@/api/products';
import type { Product } from '@/types/products';

/**
 * Duplica un producto del catálogo (módulo 3, solo ADMIN).
 *
 * El backend copia la estructura y devuelve la copia **inactiva y sin fotos**; la pantalla abre su
 * edición para cambiarle el nombre y subir las fotos nuevas. Al terminar se invalida el catálogo:
 * la copia tiene que aparecer en la tabla sin recargar.
 *
 * Es una acción poco frecuente y de ADMIN, así que invalidar de más (toda la caché) no cuesta nada y
 * evita tener que replicar aquí las query keys del módulo.
 */
export function useDuplicateProduct(tenantId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { productId: string }) => duplicateProduct(tenantId ?? '', input.productId),
    onSuccess: () => {
      void queryClient.invalidateQueries();
    },
  });
}

export type DuplicatedProduct = Product;
